import './style.scss';
import {gsap} from 'gsap'

export function hero_block() {
  const block = document.querySelector('.hero_block');
  if (!block) return;
  const title = block.querySelector('.hero-title');
  const centerCastle = block.querySelector('.center-castle');
  const whiteCastle = block.querySelector('.white-castle');
  const header = document.querySelector('header');
  
  if (!(centerCastle && whiteCastle)) return;
  
  gsap.timeline({delay:1.5, defaults:{duration:1.5, ease:'power4.in'}})
      .set(centerCastle, {scale: 1.5})
      .from(centerCastle,{opacity:0})
      .addLabel('show-all',2)
      .to(centerCastle, {scale:1}, 'show-all')
      .from(header, {yPercent:-100}, 'show-all')
      .from(title, {y:'-70vh'}, 'show-all')
      .from(whiteCastle, {yPercent:100}, 'show-all')
  
}
